import React, {createContext, ReactNode, useContext} from 'react';

type ViewModelContextType = {
  handleDurationEnds: () => void;
};

const ViewModelContext = createContext<ViewModelContextType | undefined>(
  undefined,
);

export function ViewModelProvider({children}: {children: ReactNode}) {
  const handleDurationEnds = () => {
    /* TODO: Implement this when next step is available */
  };
  return (
    <ViewModelContext.Provider value={{handleDurationEnds}}>
      {children}
    </ViewModelContext.Provider>
  );
}

export function useViewModelProvider() {
  const context = useContext(ViewModelContext);
  if (context === undefined) {
    throw new Error('AccountCreatedResult ViewModelContext is undefined');
  }
  return context;
}
